import * as React from "react";
const SvgFiRrDraftingCompass = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-drafting-compass_svg__a)">
      <path
        fill="#062147"
        d="m23.854 22.479-4.545-7.437a14.6 14.6 0 0 0 2.352-1.674 1 1 0 1 0-1.32-1.503c-.65.57-1.347 1.055-2.075 1.47l-3.045-4.983c.485-.662.78-1.47.78-2.351 0-1.858-1.279-3.411-3-3.858V1a1 1 0 1 0-2 0v1.142c-1.721.447-3 2-3 3.858 0 .881.295 1.689.78 2.351l-3.045 4.982a12.5 12.5 0 0 1-2.075-1.47 1 1 0 1 0-1.32 1.504 14.5 14.5 0 0 0 2.352 1.674L.146 22.479a1 1 0 1 0 1.707 1.042l4.648-7.606c1.76.71 3.627 1.077 5.498 1.077s3.738-.367 5.498-1.077l4.648 7.606a1 1 0 0 0 1.375.333 1 1 0 0 0 .332-1.375zM12 4c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2M7.555 14.191l2.787-4.561a4 4 0 0 0 1.657.37 4 4 0 0 0 1.657-.37l2.788 4.562a12.74 12.74 0 0 1-8.889 0z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-drafting-compass_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDraftingCompass;
